import { render, staticRenderFns } from "./RoleManage.vue?vue&type=template&id=f2818dd4&scoped=true&"
import script from "./RoleManage.vue?vue&type=script&lang=js&"
export * from "./RoleManage.vue?vue&type=script&lang=js&"
import style0 from "./RoleManage.vue?vue&type=style&index=0&id=f2818dd4&prod&lang=css&"
import style1 from "./RoleManage.vue?vue&type=style&index=1&id=f2818dd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2818dd4",
  null
  
)

export default component.exports